/* unplugin-vue-components disabled */import { render } from "./item-mm.vue?vue&type=template&id=c0d90e6e"
import script from "./item-mm.vue?vue&type=script&lang=js"
export * from "./item-mm.vue?vue&type=script&lang=js"

import "./item-mm.vue?vue&type=style&index=0&id=c0d90e6e&lang=less&scope=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__